<mds-dialog dialogTitle="File download" id="fileDownloadDialog">
    <mds-dialog-content>
        <div class="o-grid__row">
            <div class="o-grid__item">
                @if (!fileReady && !fileError) {
                    Preparing the file to download...
                } @else if (fileReady && !fileError) {
                    File is ready to be downloaded.
                } @else if (fileError) {
                    Sorry, we were unable to prepare your file for download at this time.<br />Please try again later.
                }
            </div>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button
                [id]="'cancel-btn'"
                mat-button
                mat-dialog-close
                label="Cancel"
                color="neutral"
                [variant]="'outline'"
                (clickEvent)="cancelClick()"
            ></mds-button>
            <mds-button
                [id]="'download-btn'"
                data-cy="download-btn"
                label="Download"
                (clickEvent)="onDownloadButtonClick()"
                [color]="'primary'"
                [variant]="'filled'"
                [disabled]="!fileReady || fileError"
            >
            </mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
